import React from "react";
import { t } from "../../../utils/i18n";
import { dateActivityByKey } from "../../../utils/dateActivities";
import PayRuleCallout from "../PayRuleCallout";
import type { DatePlace } from "./PlaceStep";

export default function RecapStep({
  lang, activityKey, place, date, time, onSend, onEdit, sending,
}: {
  lang: string; activityKey: string | null; place: DatePlace | null; date: string | null; time: string | null;
  onSend: () => void; onEdit: () => void; sending: boolean;
}) {
  const activity = activityKey ? dateActivityByKey(activityKey) : undefined;
  const formattedDate = date ? new Intl.DateTimeFormat(lang, { weekday: "long", day: "numeric", month: "long" }).format(new Date(`${date}T00:00:00`)) : "";

  const row = (Icon: any, label: string, value: string) => (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid #F0F0F0" }}>
      {activity ? <Icon size={17} color="#0a0a0a" /> : null}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 11, color: "#999" }}>{label}</div>
        <div style={{ fontSize: 13.5, fontWeight: 600, marginTop: 1 }}>{value}</div>
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 14 }}>{t(lang, "date_recap_title")}</div>
      <div style={{ backgroundColor: "#fafafa", borderRadius: 16, padding: "4px 14px", marginBottom: 16 }}>
        {activity && row(activity.Icon, t(lang, "date_recap_activity"), t(lang, activity.i18nKey))}
        {place && row(activity?.Icon, t(lang, "date_recap_place"), place.name)}
        {date && row(activity?.Icon, t(lang, "date_recap_date"), formattedDate)}
        {time && (
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0" }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, color: "#999" }}>{t(lang, "date_recap_time")}</div>
              <div style={{ fontSize: 13.5, fontWeight: 600, marginTop: 1 }}>{time}</div>
            </div>
          </div>
        )}
      </div>
      <PayRuleCallout lang={lang} variant="inviter" />
      <button onClick={onSend} disabled={sending} style={{ width: "100%", marginTop: 18, padding: "14px", borderRadius: 14, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 14, fontWeight: 700, cursor: sending ? "default" : "pointer", opacity: sending ? 0.6 : 1, textTransform: "uppercase", letterSpacing: 0.3 }}>
        {sending ? "..." : t(lang, "date_recap_send")}
      </button>
      <button onClick={onEdit} style={{ width: "100%", marginTop: 10, padding: "10px", border: "none", background: "none", color: "#999", fontSize: 12.5, fontWeight: 600, cursor: "pointer" }}>
        {t(lang, "date_recap_edit")}
      </button>
    </div>
  );
}
